import { useTranslation } from "react-i18next";
import { IFacility } from "redux/reducers/models/facility";

export default function MarketingOptions(facility: IFacility) {
  const { t } = useTranslation();
  const eventOptions = [
    ...(facility?.permissions?.email_marketing_create ? [{
      label: t("Email Marketing"),
      url: "/admin/marketing/email-marketing",
    }] : []),
    {
      label: t("Customer Segments"),
      url: "/admin/marketing",
    },
  ];

  return eventOptions;
}
